import { useState } from 'react';
import type { OutpatientClinicTaskWithAuthorizationAndNotes } from '@common/contexts/support/domain/types/customOutpatientClinicTaskTypes';
import type { IEpisodeCategoryBasic } from '@common/interfaces';
import { PatientTaskStatus } from '../../../../common/enums/patientTaskStatus';
import { PatientTaskItemAddEdit } from '../patientTasks/PatientTaskItemAddEdit';
import { PatientTaskItemRead } from '../patientTasks/PatientTaskItemRead';

enum TaskMode {
    addEdit = 'addEdit',
    read = 'read',
}

interface IPatientTaskProps {
    canAddTaskNote: boolean;
    canReadTaskNote: boolean;
    episodeCategory: IEpisodeCategoryBasic;
    onEditStarted: (editStarted: boolean) => void;
    onSave: () => Promise<void>;
    organizationId: string;
    patientId: string;
    task: OutpatientClinicTaskWithAuthorizationAndNotes;
}

export function PatientTask(props: IPatientTaskProps) {
    const [mode, setMode] = useState<TaskMode>(TaskMode.read);
    const [isReadModeCollapsed, setIsReadModeCollapsed] = useState(false);

    return (
        <>
            {mode === TaskMode.read && (
                <PatientTaskItemRead
                    canAddTaskNote={props.canAddTaskNote}
                    canReadTaskNote={props.canReadTaskNote}
                    episodeCategory={props.episodeCategory}
                    isCollapsed={isReadModeCollapsed || props.task.status === PatientTaskStatus.completed}
                    onEdit={() => {
                        setMode(TaskMode.addEdit);
                        setIsReadModeCollapsed(false);
                        props.onEditStarted(true);
                    }}
                    onSave={() => props.onSave()}
                    task={props.task}
                />
            )}
            {mode === TaskMode.addEdit && (
                <PatientTaskItemAddEdit
                    episodeCategory={props.episodeCategory}
                    onCancel={() => {
                        setMode(TaskMode.read);
                        setIsReadModeCollapsed(false);
                        props.onEditStarted(false);
                    }}
                    onSave={() => {
                        setMode(TaskMode.read);
                        props.onSave();
                    }}
                    organizationId={props.organizationId}
                    patientId={props.patientId}
                    task={props.task}
                />
            )}
        </>
    );
}
